/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CloseIcon - Auto-generated from icon.js
 */
export const CloseIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.8345 12L4 5.16551L5.16551 4L12 10.8345L18.8345 4L20 5.16551L13.1655 12L20 18.8345L18.8345 20L12 13.1655L5.16551 20L4 18.8345L10.8345 12Z"
			fill="#333333"
		/>
	</svg>
);

export default CloseIcon;
